import React from "react";
import { Component, createRef } from "react";
import { Button, Col, Form, Modal } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import { SingleDropdownListWithoutSearch } from "../../Common/Components/SingleDropdownListWithoutSearch";
import { DropDownList } from "../Reports/common-components/dropdown-list";
import Joi from "joi-browser";
import { Facility } from "../../Common/Services/Facility";
import { Utils } from "../../Common/Utilis";

class CompleteWorkOrderModal extends Component<any, any> {
  dialogRef = createRef<HTMLDialogElement>();
  private FormSchema = Joi.object({
    resolutionId: Joi.number()
      .required()
      .min(1)
      .error((errors) => {
        return errors.map((error) => {
          return { message: "Please select Resolution" };
        });
      }),

    notes: Joi.string().max(500)
      .error((errors) => {
        return errors.map((error) => {
          return { message: "Maximun 500 characters are allowed" };
        });
      })
      .optional().allow('')
  });
  constructor(props: any) {
    super(props);
    this.state = {
      resolutionList: [],
      formData: {
        resolutionId: -1,
        notes: ""
      },
      inputPosition: 0,
      errors: {},
      isFormNotValid: true,
    }

    this.getWorkOrderResolution()
 
  }

  getWorkOrderResolution = () => {
    Facility.GetWorkOrderResolution().then(result => {
      if (result && result?.length > 0) {
        this.setState({ resolutionList : result })
      }
    });
  }

  validateConfigurationFormSchema = (isAssetNameChanged = false) => {
    const valid = Joi.validate(
      this.state.formData,
      this.FormSchema,
      {
        abortEarly: false,
      }
    );
    const newErrorObject: any = {};
    if (valid.error) {
      valid.error.details.forEach((err) => {
        newErrorObject[err.path.join(".")] = err.message;
      });
    }

    if (Object.keys(newErrorObject).length === 0) {
      this.setState({ isFormNotValid: false });
    } else {
      this.setState({ isFormNotValid: true });
    }
    this.setState({ errors: newErrorObject });
    return newErrorObject;
  };

  
  validationOnClick = (inputPosition) => {
    this.setState({ inputPosition }, () =>
      this.validateConfigurationFormSchema()
    );
  };

  getFieldError = (fieldName: string, fieldPosition: number) => {
    const { errors, inputPosition } = this.state;

    return (
      <>
        {Object.keys(errors).length > 0 && fieldPosition <= inputPosition && (
          <span className="validation-message">{errors[fieldName]}</span>
        )}
      </>
    );
  };

  onFieldChange = (event, inputPosition) => {
    const { formData } = this.state;
    let value = event.target.value;
    const fieldName = event.target.name;
    formData[fieldName] = value;

    this.setState({ formData }, () => {
      this.validationOnClick(inputPosition);
    });
  };


  render() {
    const { isOpen, onClose } = this.props;
    const { resolutionList, formData: {
      resolution, notes
    }, errors, inputPosition, isFormNotValid} = this.state;


    if (!isOpen) return null;

    return (
      <>
        <div className="">
          <ToastContainer containerId={"addDeduction"} autoClose={3000} />

          <Modal
            className="add-room-type-modal add-new-asset add-new-asset-modal"
            show={isOpen}
            onHide={() => onClose()}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header closeButton>
              <Modal.Title>
                Complete Work Order
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="form-section">
                <div className="body-section">
                  <Form.Group
                    onBlur={() => this.validationOnClick(1)}
                    controlId="resolution" className="d-flex">
                    <Col
                      sm={"12"}
                      className={`mb-0 ${errors?.resolutionId && inputPosition >= 1
                        ? "validation-error"
                        : ""
                      }`}
                    >
                      <Form.Label>Resolution <span className="text-danger">*</span></Form.Label>

                      {resolutionList.length > 0 &&
                        <DropDownList
                          // tabIndex={2}
                          placeHolder={"Select resolution"}
                          data={resolutionList}
                          defaultValue={resolution}
                          dependent={resolution}
                          isSearchRequired={false}
                          label={"resolutionName"}
                          value={"resolutionId"}
                          placeHolderItem={{ resolutionName: "Select resolution", resolutionId: -1 }}
                          onDropDownChange={(item) => {
                            if (!item) {
                              return;
                            }
                            this.onFieldChange(
                              Utils.BuildCustomEventObject("resolutionId", item.resolutionId),
                              1
                            );
                          }}
                          selectedItem={[
                            ...[{ resolutionName: "Select resolution", resolutionId: -1 }],
                            ...resolutionList,
                          ].find((r: any) => r?.value === resolution)}
                        />}

                      {this.getFieldError("resolutionId", 1)}
                    </Col>
                  </Form.Group>


                  <Form.Group
                    controlId="additionalNotes" className="d-flex">
                    <Col
                      sm={"12"}
                      className={`mb-0 `}
                    >
                      <Form.Label>Additional Notes</Form.Label>
                      <Form.Control as="textarea"

                        className="form-control"
                        id="notes"
                        rows={1}
                        name="notes"
                        autoComplete="additionalNotes"
                        placeholder="Add any additional details about the resolution"
                        value={notes}
                        maxLength={200}
                      onChange={(e) => this.onFieldChange(e, 4)}
                      
                      />
                    </Col>
                  </Form.Group>

                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <Button
                // tabIndex={9}
                className="btn-ghost"
                onClick={() => onClose()}
              >
                Cancel
              </Button>
              <Button
                //  tabIndex={8}
                disabled={isFormNotValid || this.props.isDataSaving}
                className="btn btn-primary"
              onClick={() => this.props.onSave(this.state.formData)}
              >
                Complete
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </>
    );
  }
}
export default CompleteWorkOrderModal;